
(function(){
  var doc = document, root = doc.documentElement;
  if (root.__brfV4) return; root.__brfV4 = true;
  var desk = window.matchMedia('(min-width:1000px)');

  /* ---------- 1. Product cards: quantity box + Add to bag ---------- */
  function clampQty(input, v){
    var max = parseInt(input.getAttribute('max'), 10); if (isNaN(max) || max < 1) max = 9999;
    v = parseInt(v, 10); if (isNaN(v) || v < 1) v = 1;
    var hit = v > max; v = Math.min(v, max);
    input.value = v;
    var box = input.closest('.brf-qa__qty');
    if (box) {
      var minus = box.querySelector('[data-d="-1"]'), plus = box.querySelector('[data-d="1"]');
      if (minus) minus.disabled = v <= 1;
      if (plus) plus.disabled = v >= max;
      if (hit) { box.classList.remove('is-max'); void box.offsetWidth; box.classList.add('is-max'); }
    }
    return v;
  }
  doc.addEventListener('click', function(e){
    var st = e.target.closest && e.target.closest('.brf-qa__step'); if (!st) return;
    e.preventDefault();
    var input = st.parentNode.querySelector('.brf-qa__in'); if (!input) return;
    clampQty(input, (parseInt(input.value, 10) || 1) + parseInt(st.getAttribute('data-d'), 10));
  });
  doc.addEventListener('change', function(e){ if (e.target.classList && e.target.classList.contains('brf-qa__in')) clampQty(e.target, e.target.value); });
  doc.addEventListener('keydown', function(e){
    if (e.key !== 'Enter' || !e.target.classList || !e.target.classList.contains('brf-qa__in')) return;
    e.preventDefault(); clampQty(e.target, e.target.value);
    var add = e.target.closest('form').querySelector('.brf-qa__add'); if (add) add.click();
  });
  /* make sure a half-typed number is tidied before the theme reads the form */
  doc.addEventListener('click', function(e){
    var b = e.target.closest && e.target.closest('.brf-qa__add'); if (!b) return;
    var input = b.form && b.form.querySelector('.brf-qa__in'); if (input) clampQty(input, input.value);
    pending = b;
  }, true);
  var pending = null;
  function added(btn){
    var form = btn.closest('form'), lbl = btn.querySelector('.brf-qa__lbl');
    if (!lbl) return;
    clearTimeout(btn.__brfT);
    btn.classList.add('is-done', 'is-pop'); lbl.textContent = 'Added ✓';
    btn.__brfT = setTimeout(function(){
      btn.classList.remove('is-done', 'is-pop');
      lbl.textContent = 'Add';
      if (form) form.classList.add('is-compact');
      if (window.brfFitQa) window.brfFitQa(btn);
      btn.setAttribute('aria-label', 'Add more to bag');
      var input = form && form.querySelector('.brf-qa__in'); if (input) clampQty(input, 1);
    }, 1400);
  }

  /* ---------- 2. Quick view: adds show the "In the bag!" note on top, the window closes properly ---------- */
  var QV = '.modal[id^="modal-quick-view"]';
  /* the slim header (brf-slim-header) swaps the drawer for its note; here we just make sure the window closes */
  doc.body.addEventListener('product:added', function(e){
    var t = e.target, qv = t && t.closest && t.closest(QV);
    if (qv) { setTimeout(function(){ closeQv(qv); }, 80); return; }
    var b = pending; pending = null;
    if (b && b.isConnected && t && t.contains && t.contains(b)) added(b);
  });
  function closeQv(m){
    m = m || doc.querySelector(QV + '[aria-hidden="false"]'); if (!m || m.getAttribute('aria-hidden') !== 'false') return;
    doc.dispatchEvent(new CustomEvent('modal:close'));
    /* belt and braces: if the theme lost track of the window, close it ourselves */
    setTimeout(function(){
      if (m.getAttribute('aria-hidden') === 'false') {
        m.setAttribute('aria-hidden', 'true');
        m.dispatchEvent(new CustomEvent('modal:closed'));
      }
      if (!doc.querySelector('.modal[aria-hidden="false"]')) root.classList.remove('is-locked');
    }, 120);
  }
  /* click anywhere outside the quick view box to close it */
  doc.addEventListener('click', function(e){
    var m = doc.querySelector(QV + '[aria-hidden="false"]'); if (!m) return;
    var t = e.target, dlg = m.querySelector('.modal__dialog');
    if ((dlg && dlg.contains(t)) || !t.closest || t.closest('.brf-hc__toast, .brf-hc__bag, [data-action="open-modal"]')) return;
    e.preventDefault(); e.stopPropagation();
    closeQv(m);
  }, true);

  /* ---------- 6. Delivery card: below the link on desktop, nudged into view if needed ---------- */
  function placeShip(w, scroll){
    if (!desk.matches) return;
    var link = w.querySelector('a'), card = w.querySelector('.brf-ship__card'); if (!link || !card) return;
    var r = link.getBoundingClientRect(), h = card.offsetHeight || 300, wd = card.offsetWidth || 320;
    var cx = r.left + r.width / 2, left = cx - wd / 2, dx = 0;
    if (left < 12) dx = 12 - left; else if (left + wd > window.innerWidth - 12) dx = window.innerWidth - 12 - (left + wd);
    card.style.setProperty('--brf-ship-dx', Math.round(dx) + 'px');
    var deficit = r.bottom + 12 + h + 16 - window.innerHeight;
    if (scroll && deficit > 0) window.scrollBy({top: deficit, behavior: window.matchMedia('(prefers-reduced-motion:reduce)').matches ? 'auto' : 'smooth'});
  }
  function initShip(){
    var w = doc.querySelector('.brf-ship'); if (!w || w.__brfV4) return; w.__brfV4 = true;
    var was = false;
    new MutationObserver(function(){
      var on = w.classList.contains('is-open');
      if (on && !was) placeShip(w, true);
      was = on;
    }).observe(w, {attributes: true, attributeFilter: ['class']});
    w.addEventListener('mouseenter', function(){ placeShip(w, false); });
  }
  initShip();
  window.addEventListener('load', initShip);
  setTimeout(initShip, 1500);

  /* ---------- 8. Main header search: click anywhere to close; an empty search gets a giggle instead ---------- */
  doc.addEventListener('pointerdown', function(e){
    if (!root.classList.contains('brf-so-open') || !window.brfSearchClose) return;
    var t = e.target;
    if (!t.closest || t.closest('#brf-sp, #shopify-section-header form.search-bar, [data-action="toggle-search"], .brf-hc__search')) return;
    window.brfSearchClose();
  }, true);
  var NOTHING = [
    'You came, you saw, you… forgot to type. Happens to the best of us 😄',
    'Our search bar is clever, but it can’t read minds. Yet. 🔮',
    'Searching for nothing? We’ve got loads of that, and it’s free! 😄',
    'Even our bull needs a clue. Pop a word in! 🐂',
    'We searched high and low for “ ” and found… fresh air. Try a fabric! 🌬️',
    'Blank search, blank canvas. Type a fabric and let’s fill it 🎨',
    'Needle threaded, scissors sharpened… we just need a word ✂️',
    'Psst… the magic only works when you type something ✨',
    'Bold move, searching for nothing. Bolder move: type “velvet” 😉',
    'You searched for absolutely nothing. Very zen. Very calm. Very unhelpful 🧘',
    'Nothing in, nothing out. Even a quilt starts with one square 🧵',
    'Our bull pressed the button too. Nothing happened for him either 🐂'
  ];
  var nAt = -1;
  window.brfNothingQuip = function(){
    var i = Math.floor(Math.random() * NOTHING.length);
    if (i === nAt) i = (i + 1) % NOTHING.length;
    nAt = i; return NOTHING[i];
  };
  var mform = doc.querySelector('#shopify-section-header form.search-bar');
  var minput = mform && mform.querySelector('.search-bar__input');
  if (mform && minput) {
    var note = doc.createElement('p'); note.className = 'brf-nothing'; note.setAttribute('role', 'status'); note.setAttribute('aria-live', 'polite');
    doc.body.appendChild(note);
    var nT = 0;
    var showNote = function(){
      var r = mform.getBoundingClientRect();
      note.textContent = window.brfNothingQuip();
      note.style.top = Math.round(r.bottom + 12) + 'px';
      note.style.left = Math.round(r.left + r.width / 2) + 'px';
      note.classList.remove('is-on'); void note.offsetWidth; note.classList.add('is-on');
      mform.classList.remove('brf-shake'); void mform.offsetWidth; mform.classList.add('brf-shake');
      clearTimeout(nT); nT = setTimeout(function(){ note.classList.remove('is-on'); }, 3800);
      try { minput.focus({preventScroll: true}); } catch (err) {}
    };
    mform.addEventListener('submit', function(e){
      if (minput.value.trim()) { note.classList.remove('is-on'); return; }
      e.preventDefault(); e.stopImmediatePropagation(); showNote();
    }, true);
    minput.addEventListener('input', function(){ if (minput.value.trim()) note.classList.remove('is-on'); });
    window.addEventListener('scroll', function(){ note.classList.remove('is-on'); }, {passive: true});
  }
})();
